import { browser } from '$app/environment';
import { getDoc, doc } from 'firebase/firestore';
import { logError } from '$lib/helpers/errors';
import { db } from '$lib/firestore';

// Cache to store stock levels temporarily (optional)
let stockCache = {};

export async function checkStock(pid) {
  if (!browser || !pid) {
    console.warn(`checkStock called with invalid parameters: browser=${browser}, pid=${pid}`);
    return null;
  }

  // Check cache first (optional, for performance improvement)
  if (stockCache[pid]) {
    return stockCache[pid];
  }

  try {
    const firestore = await db();
    const productRef = doc(firestore, "products", pid);
    const productDoc = await getDoc(productRef);

    if (!productDoc.exists()) {
      console.warn(`Product with pid ${pid} does not exist in db.`);
      return null;
    }

    const productData = productDoc.data();
    const stock = productData?.stock;

    // Check if stock is a valid number
    if (typeof stock !== 'number' || stock < 0) {
      console.warn(`Invalid stock data for product ${pid}.`);
      return null;
    }

    // Cache the stock value (optional)
    stockCache[pid] = stock;

    return stock;
  } catch (error) {
    console.error(`Error checking stock for product ${pid}:`, error);
    logError('checkStock', error); // Use your custom error logging function
    return null;
  }
}
